import { Stack, Typography, type SxProps, type Theme } from '@mui/material'
import { type SurveyElement } from '../MidYearSummary'
import { FileDownloadCard } from './FileDownloadCard'
import { SURVEY_COMMENT_SUFFIX, SURVEY_FILE_KEY_SUFFIX, SURVEY_FILE_SUFFIX } from '../../../../../../../constants/surveyConstants'
import { linkifyText } from '../../../../../../../utils/linkifyText'
import { parseSurveyText } from '../../../../../../customComponents/survey/questions/components/parseSurveyText'

const styles: Record<string, SxProps<Theme>> = {
  questionLabel: {
    color: 'var(--BaseTones-primitive-nuetral-900, rgba(37, 36, 38, 1))',
    fontSize: '0.95rem'
  },
  answerText: {
    fontWeight: 'bold'
  }
}

interface Props {
  element: SurveyElement
  answers: Record<string, any>
}
export const SummaryRadio = ({ element, answers }: Props): JSX.Element => {
  const answer = answers[element.name]
  const comment = answers[element.name + SURVEY_COMMENT_SUFFIX]
  const fileName = answers[element.name + SURVEY_FILE_SUFFIX]
  const fileKey = answers[element.name + SURVEY_FILE_KEY_SUFFIX]

  const selectedOption = answer != null && element.radioMatrix != null ? element.radioMatrix[answer] : null
  const hasTextComment = selectedOption?.hasTextInput === true && comment != null && comment !== ''

  const hasFileUpload = element.radioMatrix != null && Object.values(element.radioMatrix).some(option => option.hasUpload === true)
  const shouldShowFileUpload = hasFileUpload && fileName != null && fileKey != null // TODO: Placeholder for any additional conditions to show the file upload section (e.g., specific answer values)

  const isInvoiceQuestion = element.title?.toLowerCase().includes('invoicing start') === true
  const isInvoiceQuestionAnsweredYes = isInvoiceQuestion && answer === 'Yes'

  const shouldShowNoInvoiceAttached = hasFileUpload && isInvoiceQuestionAnsweredYes && fileKey == null

  const isMaterialQuestion = element.title?.toLowerCase().includes('materials') === true
  const isMaterialQuestionAnsweredYes = isMaterialQuestion && answer === 'Yes'
  const shouldShowNoMaterialsAttached = hasFileUpload && isMaterialQuestionAnsweredYes && fileKey == null

  return (
    <Stack gap={1}>
      <Typography variant='body1' sx={styles.questionLabel}>{parseSurveyText(element.title)}</Typography>
      {answer != null
        ? <Typography variant='body1' sx={styles.answerText}>{answer}</Typography>
        : <Typography variant='body1' color={'text.disabled'}>No response provided</Typography>
      }
      {shouldShowNoInvoiceAttached && (
        <Typography variant='body2' fontStyle='italic'>No invoice attached</Typography>
      )}
      {shouldShowNoMaterialsAttached && (
        <Typography variant='body2' fontStyle='italic'>No materials attached</Typography>
      )}
      {hasTextComment && (
        <Typography variant='body1' fontWeight='bold' color='var(--BaseTones-primitive-nuetral-500, rgba(89, 85, 91, 1))'>
          {linkifyText(comment)}
        </Typography>
      )}
      {shouldShowFileUpload && <FileDownloadCard fileName={fileName} fileKey={fileKey} />}
    </Stack>
  )
}
